import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { faLightbulbOn } from '@fortawesome/pro-regular-svg-icons/faLightbulbOn';
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import DashboardSearchTip from './DashboardSearchTip';

type Props = Readonly<{
  classNames?: {
    container?: string;
    tipText?: string;
    iconClassNames?: {
      diabetes?: string;
      heartFailure?: string;
      copd?: string;
    };
  };
}>;

/**
 * DashboardSearchTips row: example search suggestions shown below the search input.
 */
const DashboardSearchTips = ({ classNames }: Props = {}) => {
  const { iconClassNames, container, tipText } = classNames || {};
  return (
    <Flex data-testid="dashboard-search-tips" className={cn(container)}>
      <DashboardSearchTip
        icon={faLightbulbOn}
        iconClassName={cn(
          'text-orange-400 mr-2 w-[30px] h-[30px]',
          iconClassNames?.diabetes,
        )}
        dataTestId="dashboard-search-lightbulb-icon"
        type="diabetes"
        textClassName={tipText}
      />

      <DashboardSearchTip
        icon={faCircle}
        iconClassName={cn(
          'text-slate-600 mx-2 w-2 h-2',
          iconClassNames?.heartFailure,
        )}
        type="heartFailure"
        textClassName={tipText}
      />

      <DashboardSearchTip
        icon={faCircle}
        iconClassName={cn('text-slate-600 mx-2 w-2 h-2', iconClassNames?.copd)}
        type="copd"
        textClassName={tipText}
      />
    </Flex>
  );
};

export default DashboardSearchTips;
